import { FC, useState } from 'react';
import React, { FormEventHandler } from 'react';

import styled from '@emotion/styled';

import { Box, ButtonLink, TextButton } from '@clutter/clean';

import { Button } from '@portal/components/shared/button';
import { Banner as ErrorBanner } from '@portal/components/shared/error';
import { Input } from '@portal/components/shared/form';
import { client } from '@portal/libraries/apollo';
import { Status, useSignInVerifyMutation } from '@portal/schema';

const PIN = styled(Input)`
  letter-spacing: 12px;
  text-align: center;
`;

const Hint = styled.p`
  text-align: center;
`;

const PLACEHOLDER = '•';
const LENGTH = 6;

export const LoginMFAForm: FC<{
  email: string;
  password: string;
  mfaRequestID: string;
  onReset(): void;
}> = ({ email, password, mfaRequestID, onReset }) => {
  const [code, setPIN] = useState<string>('');
  const [execute, { data, loading }] = useSignInVerifyMutation({ client });
  const error = data?.result?.error;

  const onSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const response = await execute({
      variables: {
        input: {
          email,
          password,
          mfaRequestID,
          code,
        },
      },
    });
    const status = response.data?.result?.status;
    if (status === Status.Ok) location.replace('/restore');
  };

  return (
    <form onSubmit={onSubmit}>
      <Box.Flex flexDirection="column" gap="24px">
        <Hint>Please check your email for a 6-digit code to continue.</Hint>
        {error && <ErrorBanner>{error}</ErrorBanner>}

        <Box.Flex flexDirection="column">
          <PIN
            id="code"
            type="text"
            value={code}
            required
            pattern="[0-9]{6}"
            placeholder={PLACEHOLDER.repeat(LENGTH)}
            onChange={(event) => setPIN(event.target.value)}
            autoFocus
            autoComplete="off"
            inputMode="numeric"
          />
        </Box.Flex>

        <Button kind="primary" size="medium" loading={loading} disabled={code.length !== LENGTH}>
          Confirm
        </Button>

        <TextButton onClick={onReset}>Reset</TextButton>
      </Box.Flex>
    </form>
  );
};
